import { render, staticRenderFns } from "./TranslationAiOverlay.vue?vue&type=template&id=fc37872a&"
import script from "./TranslationAiOverlay.vue?vue&type=script&lang=js&"
export * from "./TranslationAiOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports